import { render, staticRenderFns } from "./GroupMember.vue?vue&type=template&id=0263d3e6&scoped=true"
import script from "./GroupMember.vue?vue&type=script&lang=js"
export * from "./GroupMember.vue?vue&type=script&lang=js"
import style0 from "./GroupMember.vue?vue&type=style&index=0&id=0263d3e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0263d3e6",
  null
  
)

export default component.exports